import formValidation from './components/form-validation';
import contentAccordion from './components/content-accordion';
import smoothScroll from './components/smooth-scroll';
import mobileMenu from './components/mobile-menu';

(($) => {

  $(() => {

    formValidation();
    contentAccordion();
    smoothScroll();
    mobileMenu();

  });

})($);
